
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[slug]",
      function () {
        return require("private-next-pages/project/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/[slug]"])
      });
    }
  